import { StyleSheet, Text, View } from "@react-pdf/renderer";
import React from "react";
import { PDF_INK, PDF_ORANGE, PDF_ORANGE_TINT } from "./pdfTheme";

const RADIUS = 3;

const styles = StyleSheet.create({
    docket: { flexDirection: "row" },
    tab: { width: 5, backgroundColor: PDF_ORANGE, borderTopLeftRadius: RADIUS, borderBottomLeftRadius: RADIUS },
    content: {
        flexGrow: 1,
        backgroundColor: PDF_ORANGE_TINT,
        borderTopRightRadius: RADIUS,
        borderBottomRightRadius: RADIUS,
    },
    top: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        paddingHorizontal: 9,
        paddingVertical: 4,
        borderBottomWidth: 1,
        borderBottomColor: PDF_INK,
        borderBottomStyle: "dashed",
    },
    label: { fontSize: 6.5, fontWeight: 900, letterSpacing: 1.2, textTransform: "uppercase" },
    body: { paddingHorizontal: 9, paddingVertical: 5 },
});

interface Props {
    label: string;
    // Shown at the right of the label strip, e.g. a status tag.
    aside?: React.ReactNode;
    style?: any;
    bodyStyle?: any;
    children: React.ReactNode;
}

// A box styled like a delivery docket: an orange tab down its left edge and a dashed perforation under
// its label, on a pale orange fill light enough to print cleanly on site printers. Used for the delivery window and
// the jobsite's delivery hours.
const PdfDocket: React.FC<Props> = ({ label, aside, style, bodyStyle, children }) => (
    <View style={style ? [styles.docket, style] : styles.docket}>
        <View style={styles.tab} />
        <View style={styles.content}>
            <View style={styles.top}>
                <Text style={styles.label}>{label}</Text>
                {aside}
            </View>
            <View style={bodyStyle ? [styles.body, bodyStyle] : styles.body}>{children}</View>
        </View>
    </View>
);

export default PdfDocket;
